import React, { useEffect } from 'react';
import { Image } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';

interface ImagePreviewGroupProps {
  images: string[] | UploadFile[];
  imageWidth?: number;
  imageHeight?: number;
  gap?: number;
  padding?: number;
}

const ImagePreviewGroup: React.FC<ImagePreviewGroupProps> = ({
  images,
  imageWidth = 100,
  imageHeight = 100,
  gap = 10,
  padding = 5,
}) => {
  const normalizedUrls = Array.isArray(images) && typeof images[0] === 'string'
    ? (images as string[])
    : (images as UploadFile[]).map((file) => file.url).filter(Boolean) as string[];

useEffect(() => {
  normalizedUrls.forEach((url) => {
    const img = new window.Image();
    img.src = url;
  });
}, [normalizedUrls]);


  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap,
        padding,
      }}
    >
      <Image.PreviewGroup>
        {normalizedUrls.map((url, index) => (
          <Image
            key={index}
            src={url}
            width={imageWidth}
            height={imageHeight}
            alt={`Image ${index + 1}`}
            style={{
              objectFit: 'cover',
              borderRadius: 8,
            }}
          />
        ))}
      </Image.PreviewGroup>
    </div>
  );
};

export default ImagePreviewGroup;
